import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/uiKit/atoms/Button.tsx';
import { CardFooter } from '@/uiKit/atoms/card/CardFooter.tsx';
import {
  CarePlanRenewalInfo,
  SimpleCarePlanRenewalInfo,
} from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewal.ts';
import { CARE_PLAN_RENEWAL_FORM_ID } from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewalForm.tsx';

export type CarePlanRenewalFormActionsProps = {
  onBack?: (data: Partial<CarePlanRenewalInfo>) => void;
};

export const CarePlanRenewalFormActions: React.FC<
  CarePlanRenewalFormActionsProps
> = ({ onBack }) => {
  const formContext = useFormContext<SimpleCarePlanRenewalInfo>();
  const { t } = useTranslation();

  return (
    <CardFooter>
      <Button
        variant="outlined"
        id="care-plan-renewal-cancel"
        onClick={() =>
          onBack && onBack(formContext.getValues() as CarePlanRenewalInfo)
        }
      >
        {t('button.back')}
      </Button>
      <Button
        form={CARE_PLAN_RENEWAL_FORM_ID}
        id="care-plan-renewal-next"
        type="submit"
        variant="contained"
      >
        {t('button.next')}
      </Button>
    </CardFooter>
  );
};
